import http from "../http-common"

class NotificationServices {
    getAllNotificationModel() {
        return http.get("/notification?pagePath=%2FNotificationContent")
    }
}


export default new NotificationServices();